import api from "./axiosConfig";

export interface NewsletterReq {
  email: string;
}
export interface NewsletterRes {
  message: string;
}

export const Newsletter = async (data: NewsletterReq) => {
  const response = await api.post<NewsletterRes>(
    "/other/newsletter/subscribe",
    data
  );
  return response.data;
};
